<div
  class="item-type-label"
  [class]="parsedType().class">
  {{ parsedType().label | titlecase }}
</div>
